import Http from '@/services/http';
import {
  PagedRegionalListRequest,
  PagedRegionalListResponse,
  RegionalLookupRequest,
  Lookup,
} from 'sigma-mappings';

const urls = {
  getRegionalList: '/regional/listagem',
  regionalLookup: '/regional/lookup',
  removeRegional: id => `/regional/${id}`,
};

export default {
  /**
   * Obtem a lista de regionais. Trabalha com requisição e respostas paginadas.
   * @param {PagedRequest} pagedRequest
   * @param {*} pagedRequest.filter Objeto de filtros da requisição.
   */
  getRegionalList({
    page, pageSize, sort, filter,
  }) {
    const http = new Http();
    return http.post(urls.getRegionalList, new PagedRegionalListRequest({
      page,
      pageSize,
      sort,
      filter,
    }))
      .then(({ data }) => new PagedRegionalListResponse(data));
  },
  /**
   * Remove uma regional
   * @param {*} regionalId id da regional
   */
  removeRegional(regionalId) {
    const http = new Http();
    return http.delete(urls.removeRegional(regionalId));
  },
  getRegionalLookup(companiesIds) {
    const http = new Http();
    return http.post(urls.regionalLookup, new RegionalLookupRequest({
      companiesIds,
    })).then(({ data }) => data.map(item => new Lookup(item)));
  },
};
